<template>
	<div class="about--wrapper">
		<Header></Header> 
		<div class="about">
			<div>
				<h2 class="page--title"><u>About Us</u></h2>
			</div>
			<div class="about--items">
				<p class="about--item">Algoforms (“we”, “us” or “our”) is an online data collection company that makes it easy for partners and/or users to collect data online and remotely from users or customers.</p>
				<p class="about--item">We are one of the leading data collection startup with vast experience in data capture services for clients across the world. We obtain online consumer data in emerging economies and of competitor businesses.</p>
				<p class="about--item">At Algoforms, we believe that the quality of data is one of the most critical factors in the success of a project. Our online data collection services assist clients in obtaining the required data from carefully scrutinized sources. We ensure that the quality of our data respondents and web sources is maintained.</p>
				<p class="about--item">Our process involves excluding duplicates and redundant/obsolete information so that only relevant data is added to your database. We have developed automated tools to ensure a large volume of data is scraped from any website. Our fast and flexible data collection solutions have a faster turnaround to save the client’s time and reduce the cost of operations.</p>
				<p class="about--item">Accurate data is vital for any business; thus, it must be verified before it is used for strategizing or compiling it with the master database of your company. This is why we help you improve and enhance your database by offering unmatched data verification services either through web research or by directly speaking to the relevant person and gathering correct information.</p>
				<p class="about--item">We are an independent contractor for all purposes, providing this website and our services on an independent service provider basis. We are one of the leading web research startup with experience in providing tech-enabled solutions to both B2B and B2C clients across the world. Our data experts ensure the highest-quality, efficient processing, and internationally-compliant data management solutions for our clients.</p>
			</div>
		</div>
		<Main></Main>
		<Footer></Footer> 
	</div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/partials/Header.vue";
import Footer from "@/components/partials/Footer.vue";
import Main from "@/components/partials/Main.vue";
export default {
  name: "About",
  components: {
    Header,
    Footer,
    Main,
  },
  data() {
    return {
      menu: false,
    };
  },
  computed: {},
  methods: {},
};
</script>

<style scoped>
/* About */
.about {
  margin: 1rem;
  /* background-color: #f5f5f5; */
}
.page--title {
  text-align: center;
  margin-top: 0.75rem;
  margin-bottom: 2rem;
}
.about--item {
  text-align: left;
  margin-bottom: 2rem;
}
/* Wider screen */
@media screen and (min-width: 981px) {
  .about {
    width: 70%;
    margin: 0 auto;
  }
}
</style>